import { Dispatch, SetStateAction, useState } from 'react';

import { DeleteOutlined } from '@mui/icons-material';
import { Box, ButtonBase } from '@mui/material';

import { Dialog, DialogButton, DialogContentText } from '@/components/Dialog';
import { regularChartPalette } from '@/constants/constants';
import HeadContent from '@/pages/DataHub/Preview/HeadContent';
import useDataHubSelector from '@/pages/DataHub/useDataHubSelector';

import { separator } from './constants';

const ColumnHeader = ({
  columnKey,
  index,
  isSummary,
  open,
  setOpen
}: {
  columnKey: string;
  index: number;
  isSummary?: boolean;
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
}) => {
  const [, , , code, title, alias, currency, units] = columnKey.split(separator);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { deleteColumnFromDataHub } = useDataHubSelector();

  const handleDeleteSymbol = () => {
    deleteColumnFromDataHub(columnKey);
    setIsModalOpen(false);
  };

  const backgroundColor = index < 4 && isSummary ? regularChartPalette[index] : 'text.primary';
  return (
    <>
      <Box
        onClick={() => {
          setOpen(o => !o);
        }}
      >
        <Box
          sx={{
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            gap: '8px'
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'end',
              justifyContent: 'space-between',
              userSelect: 'none',
              px: open ? '8px' : 0
            }}
          >
            {open ? (
              title
            ) : (
              <Box
                sx={{
                  display: '-webkit-box',
                  WebkitBoxOrient: 'vertical',
                  WebkitLineClamp: 2,
                  overflow: 'hidden'
                }}
              >
                {title}
              </Box>
            )}
            <Box sx={{ display: 'flex', alignItems: 'end', height: '48px' }}>
              <ButtonBase
                sx={{ ml: 0.8, mr: 0, p: 0 }}
                onClick={e => {
                  e.stopPropagation();
                  setIsModalOpen(true);
                }}
              >
                <DeleteOutlined sx={{ fontSize: 21 }} />
              </ButtonBase>
            </Box>
          </Box>
          {open && (
            <HeadContent
              {...{
                code,
                alias,
                currency,
                units
              }}
            />
          )}

          <Box
            sx={{
              height: index < 4 && isSummary ? 4 : 2,
              mt: 0.5,
              width: '100%',
              backgroundColor
            }}
          />
        </Box>
      </Box>
      <Dialog
        buttons={
          <>
            <DialogButton
              variant='contained'
              onClick={handleDeleteSymbol}
            >
              Remove
            </DialogButton>
            <DialogButton
              variant='outlined'
              onClick={() => {
                setIsModalOpen(false);
              }}
            >
              Cancel
            </DialogButton>
          </>
        }
        open={isModalOpen}
        title='Remove item?'
        onClose={() => {
          setIsModalOpen(false);
        }}
      >
        <DialogContentText>This item will be removed from the Data Hub</DialogContentText>
      </Dialog>
    </>
  );
};

export default ColumnHeader;
